import { Flex } from '@chakra-ui/react';
import type { ReactNode } from 'react';

export interface LastMessageTextProps {
  children: ReactNode;
}

export function LastMessageText({ children }: LastMessageTextProps) {
  return (
    <Flex
      className="LastMessageText"
      maxW="full"
      color="fg.muted"
      fontSize="xs"
      fontWeight="medium"
      truncate
      alignItems="center"
    >
      {children}
    </Flex>
  );
}
